import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import { formatPercent, formatVolume } from '../../../utils/numberFormatFunc'

const MobileOptionTrade = ({modalDate,ticker,expiration,modalRowData,upperData }) => {
  return (
    <div>
    <h5
      style={{
        marginBottom: 0,
        marginTop: 10,
        marginLeft: "10px",
        fontSize: "1rem",
      }}>
      Options Trade
    </h5>
    <div
      style={{
        color: "gray",
        marginBottom: "10px",
        marginLeft: "10px",
        fontSize: "0.75rem",
      }}>
      {moment(modalDate).format("MMM DD YYYY")}
    </div>
    <Table>
      <TableHead>
        <TableRow
          style={{ backgroundColor: "#043055", height: "24px" }}>
          <TableCell
            style={{
              color: "white",
              fontSize: "0.75rem",
              width: "40%",
              padding: 0,
            }}
            align='center'>
            OPTION
          </TableCell>
          <TableCell
            style={{
              color: "white",
              fontSize: "0.75rem",
              width: "10%",
              padding: 0,
            }}
            align='center'>
            VOL
          </TableCell>
          <TableCell
            style={{
              color: "white",
              fontSize: "0.75rem",
              width: "10%",
              padding: 0,
            }}
            align='center'>
            OI
          </TableCell>
          <TableCell
            style={{
              color: "white",
              fontSize: "0.75rem",
              padding: 0,
            }}
            align='center'>
            IVOL
          </TableCell>
          <TableCell
            style={{
              color: "white",
              fontSize: "0.75rem",
              padding: 0,
            }}
            align='center'>
            CHG
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.keys(upperData).length ? (
          <TableRow key={ticker} style={{ height: "24px" }}>
            <TableCell
              style={{
                fontSize: "0.75rem",
                width: "40%",
                padding: 0,
              }}
              align='center'>
              {ticker +
                " " +
                (expiration
                  ? moment(expiration).format("DD-MMM-YY")
                  : "") +
                " $" +
                modalRowData.strike +
                ` ${
                  modalRowData.put_call === "P" ? " Puts" : " Calls"
                }`}
            </TableCell>
            <TableCell
              style={{
                fontSize: "0.75rem",
                width: "10%",
                padding: 0,
              }}
              align='center'>
              {formatVolume(upperData.volume)}
            </TableCell>
            <TableCell
              style={{
                fontSize: "0.75rem",
                width: "10%",
                padding: 0,
              }}
              align='center'>
              {formatVolume(upperData.open_int)}
            </TableCell>
            <TableCell
              align='center'
              style={{
                fontSize: "0.75rem",
                width: "10%",
                padding: 0,
              }}>
              {formatPercent(upperData.ivol)}%
            </TableCell>
            <TableCell
              align='center'
              style={{
                fontSize: "0.75rem",
                width: "10%",
                padding: 0,
              }}>
              <span
                style={
                  upperData.ivol_chg > 0
                    ? { color: "green" }
                    : { color: "red" }
                }>
                {upperData.ivol_chg > 0
                  ? "+" +
                    (
                      Math.round(
                        upperData.ivol_chg * 1000
                      ) / 10
                    ).toFixed(1)
                  : (
                      Math.round(
                        upperData.ivol_chg * 1000
                      ) / 10
                    ).toFixed(1)}
              </span>
            </TableCell>
          </TableRow>
        ) : (
          "Please Wait"
        )}
      </TableBody>
    </Table>
  </div>
  )
}

export default MobileOptionTrade


// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/MobileOptionTrade.jsx